/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface PasswordVerifyChallenge
 */
export interface PasswordVerifyChallenge {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordVerifyChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordVerifyChallenge
     */
    authentication_method: FactorMethod;
}

/**
 * Check if a given object implements the PasswordVerifyChallenge interface.
 */
export function instanceOfPasswordVerifyChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function PasswordVerifyChallengeFromJSON(json: any): PasswordVerifyChallenge {
    return PasswordVerifyChallengeFromJSONTyped(json, false);
}

export function PasswordVerifyChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function PasswordVerifyChallengeToJSON(value?: PasswordVerifyChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
    };
}

